import $ from 'jquery';
import radio from 'radio';
import viewport from 'lib-unicorn/viewport';
import {
  CLICK,
} from 'shared/enums/events';

// Fuzzy adjustmnet when fonts real height <> lineheight.
const scrollHeightFontCorrection = 2;

export default function expanderClient() {
  radio(CLICK).subscribe((event, $target) =>
    $target
      .closest('.component.expander .open-button')
      .closest('.component.expander')
      .toggleClass('expander-open')
      .find('.expander-inner')
      .css('max-height', 'none'),
    );

  const initArticleExpander = function initArticleExpander($context) {
    const $inner = $('.expander-inner', $context);
    $inner.show();

    if (!viewport().isMobile()) {
      return false;
    }
    const $firstAd = $('.ad-container:visible', $inner).first();
    const $button = $('.expander-button', $context);
    if (!$inner.length || !$firstAd.length || !$button.length) {
      return false;
    }

    // Extra offset to extend a couple lines into next paragraph.
    const xtraOffset = 90;
    const yOffset = $firstAd.position().top + $firstAd.outerHeight(true) + xtraOffset;
    $inner.css('max-height', `${yOffset}px`);
    $button.show();

    return true;
  };

  const initSimpleExpander = function initSimpleExpander($context) {
    const $inner = $('.expander-inner', $context);
    $inner.show();

    const $button = $('.expander-button', $context);
    if (!$inner.length || !$button.length) {
      return false;
    }
    if ($inner[0].scrollHeight - scrollHeightFontCorrection <= $inner.height()) {
      $context.addClass('expander-open');
      return false;
    }
    $button.show();

    return true;
  };

  // Initialize expanders as needed.
  return $('.component.expander').each(function initExpander() {
    if ($(this).data('article')) {
      return initArticleExpander($(this));
    }
    return initSimpleExpander($(this));
  });
}



// WEBPACK FOOTER //
// ./~/unicorn/shared/components/expander/client.js